import { Card } from 'antd'
import styled from 'styled-components'

export const StyledCard = styled(Card)`
  height: 100%;
  cursor: pointer;
`
